// Package imports:
import React, { memo } from 'react';
// Component imports:
import Link from '../../ui-elements/Link/Link';
// Service imports:
import { getTimeFromDate } from '../../services/utils';

interface IProps {
    title: string | null,
    url?: string | null,
    time: string | null,
    allDay: boolean
}

const CalendarItem: React.FC<IProps> = ({
    title,
    url,
    time,
    allDay
}) => {
    return (
        <li className="events-calendar__item">
            <Link
                url={url ?? '#'}
                targetBlank
                splitLines
                linkSize='15'
            >
                {title}
            </Link>

            {!allDay && time && (
                <em>kl. {getTimeFromDate(time, 'HH:MM')}</em>
            )}
        </li>
    )
}

export default memo(CalendarItem)
